export default __webpack_public_path__ + "static/media/1st.81975de7.svg";